import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { DynamicFieldDirective } from './components/dynamic-field/dynamic-field.directive';
import { DynamicFormComponent } from './containers/dynamic-form/dynamic-form.component';
import { FormButtonComponent } from './components/form-button/form-button.component';
import { FormInputComponent } from './components/form-input/form-input.component';
import { FormSelectComponent } from './components/form-select/form-select.component';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { FormHiddenComponent } from './components/form-hidden/form-hidden.component';
import { FormCancelSaveComponent } from './components/form-cancel-save/form-cancel-save.component';
import { FormSelectCrudComponent } from './components/form-select-crud/form-select.component';
import { FormImageComponent } from './components/form-image/form-image.component';
import { WebcamComponent, WebcamModule } from 'ngx-webcam';
import { DeviceTypeSelectDialogComponent } from './components/form-image/device-type-select-dialog/device-type-select-dialog.component';
import { FormInputCurrencyComponent } from './components/form-input-currency/form-input.component';
import { FormInputNumberComponent } from './components/form-input-number/form-input.component';
import {
  CurrencyMaskConfig,
  CurrencyMaskModule,
  CURRENCY_MASK_CONFIG,
} from 'ng2-currency-mask';
import { FormSlideToggleComponent } from './components/form-slide-toggle/form-slide-toggle.component';
import { FormInputDateComponent } from './components/form-input-date/form-input-date.component';
import { FormInputTextareaComponent } from './components/form-input-textarea/form-input-textarea.component';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.',
};

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    WebcamModule,
    CurrencyMaskModule,
  ],
  declarations: [
    DynamicFieldDirective,
    DynamicFormComponent,
    FormButtonComponent,
    FormInputComponent,
    FormInputCurrencyComponent,
    FormInputNumberComponent,
    FormSelectComponent,
    FormSelectCrudComponent,
    FormHiddenComponent,
    FormCancelSaveComponent,
    FormImageComponent,
    FormSlideToggleComponent,
    FormInputDateComponent,
    FormInputTextareaComponent,
    DeviceTypeSelectDialogComponent,
  ],
  exports: [DynamicFormComponent],
  entryComponents: [
    FormButtonComponent,
    FormInputComponent,
    FormSelectComponent,
    FormSelectCrudComponent,
    FormInputDateComponent,
    FormInputTextareaComponent,
  ],
  providers: [
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
  ],
})
export class DynamicFormModule { }
